import { get, post } from './api';
import { CoinBalance, CoinPackage, CoinPurchase, CoinTransaction } from '../types/coin';

// Get the user's coin balance
export const getCoinBalance = async (): Promise<CoinBalance> => {
  return get<CoinBalance>('/coins/balance');
};

// Get available coin packages
export const getCoinPackages = async (): Promise<CoinPackage[]> => {
  return get<CoinPackage[]>('/coins/packages');
};

// Create Stripe checkout session
export const createCheckoutSession = async (data: CoinPurchase): Promise<{checkout_url: string, session_id: string}> => {
  return post('/coins/create-checkout-session', data);
};

// Purchase coins (legacy - now redirects to Stripe)
export const purchaseCoins = async (data: CoinPurchase): Promise<any> => {
  const checkoutData = await createCheckoutSession(data);
  // Redirect to Stripe checkout
  window.location.href = checkoutData.checkout_url;
  return checkoutData;
};

// Get the user's coin transactions
export const getCoinTransactions = async (): Promise<CoinTransaction[]> => {
  return get<CoinTransaction[]>('/coins/transactions');
};
